import { createSlice } from "@reduxjs/toolkit";

const blogsSlice = createSlice({
  name: "blogs",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    setBlogsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setBlogs(state, action) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setBlogsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  setBlogsLoading, 
  setBlogs, 
  setBlogsError 
} = blogsSlice.actions;

export default blogsSlice.reducer;